import React from "react";
import { Wordmark } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12 grid md:grid-cols-4 gap-10">
        <div>
          <Wordmark />
          <p className="text-sm text-slate-400 mt-4 max-w-xs">
            Enterprise intelligence platform for the United States and Canada. From data to intelligence. From intelligence to action.
          </p>
        </div>
        <div>
          <div className="tech-label mb-3">PLATFORM</div>
          <ul className="text-sm text-slate-300 space-y-2">
            <li>Commercial Excellence</li>
            <li>Board Intelligence</li>
            <li>Data & AI Foundations</li>
            <li>Action Workflows</li>
          </ul>
        </div>
        <div>
          <div className="tech-label mb-3">COMPANY</div>
          <ul className="text-sm text-slate-300 space-y-2">
            <li>About</li>
            <li>Security</li>
            <li>Careers</li>
            <li>Partners</li>
          </ul>
        </div>
        <div>
          <div className="tech-label mb-3">MARKETS</div>
          <ul className="text-sm text-slate-300 space-y-2">
            <li>United States</li>
            <li>Canada</li>
            <li>FMCG / CPG</li>
            <li>Banking & Governance</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <div className="text-xs text-slate-500 font-mono">© 2026 XYLOCTRA · SOC 2 · ISO 27001 · SYNTHETIC-DATA-DEMO-BUILD</div>
          <div className="text-xs text-slate-500">Illustrative scenarios. Not actual client results.</div>
        </div>
      </div>
    </footer>
  );
}
